import React from 'react';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!user) {
    return (
      <div className="login-message">
        <p>Please sign in to access this page</p>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
